// extracted by mini-css-extract-plugin
module.exports = {"digital-input":"styles_digital-input_1n_rD0eB-3b4Fm9OzWjWFj","digitalInput":"styles_digital-input_1n_rD0eB-3b4Fm9OzWjWFj"};